import React from 'react';
import PropTypes from 'prop-types';
import strings from 'localization/strings';
import routes from 'routes';
import landingPages from 'enums/landingPages';
import storageGroupCategories from 'enums/storageGroupCategories';
import { getGeographyLocationLandingPageUrl } from 'helpers/GeographyHelper';

import MarginBox from 'common/MarginBox';
import Breadcrumbs from 'common/Breadcrumbs';

const StorageSiteBreadcrumbs = ({ storageSite, storageGroupCategory }) => {
    const landingPage = landingPages[storageGroupCategory.key];
    const breadcrumbs = [
        {
            label: strings.home,
            url: routes.index
        },
        {
            label: strings.formatString(storageGroupCategories[storageGroupCategory.key].geographyListTitle, storageSite.city),
            url: getGeographyLocationLandingPageUrl(landingPage, storageSite.city)
        },
        {
            label: storageSite.title
        }
    ];

    return (
        <MarginBox top={2}>
            <Breadcrumbs items={breadcrumbs} />
        </MarginBox>
    );
};

StorageSiteBreadcrumbs.propTypes = {
    storageSite: PropTypes.object.isRequired,
    storageGroupCategory: PropTypes.object.isRequired
};

export default StorageSiteBreadcrumbs;
